import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import DashboardPage from "./pages/DashboardPage";
import StatesPage from "./pages/StatesPage";
import PharmaciesPage from "./pages/PharmaciesPage";
import MedicinesPage from "./pages/MedicinesPage";
import PatientsPage from "./pages/PatientsPage";
import PatientDetailPage from "./pages/PatientDetailPage";
import OrdersPage from "./pages/OrdersPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import CreateOrderPage from "./pages/CreateOrderPage";
import SurveysPage from "./pages/SurveysPage";
import SurveyDetailPage from "./pages/SurveyDetailPage";
import ReceiptsPage from "./pages/ReceiptsPage";
import ReceiptPage from "./pages/ReceiptPage";
import PharmacyManagementPage from "./pages/PharmacyManagementPage";
import ProvidersPage from "./pages/ProvidersPage";
import NotFound from "./pages/NotFound";
import LoginPage from "./pages/LoginPage";
import OtpVerificationPage from "./pages/OtpVerificationPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { isAuthenticated, setupSessionTimeout } from "./services/auth";
import ReceiptPagePublic from "./pages/ReceiptPagePublic";

function App() {
  // Set up session timeout for the entire app
  useEffect(() => {
    if (isAuthenticated()) {
      const cleanupTimeout = setupSessionTimeout(20160); // 20160 minutes timeout
      return () => cleanupTimeout(); // Cleanup on unmount
    }
  }, []);

  return (
    <ThemeProvider>
      <Routes>
        {/* Health check - no auth guard */}
        <Route path="/health" element={<pre style={{ margin: 0, fontFamily: 'monospace' }}>OK</pre>} />

        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verify-otp" element={<OtpVerificationPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        <Route path="receipt/:id" element={<ReceiptPagePublic />} />
        
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="patients" element={<PatientsPage />} />
          <Route path="patients/:patientId" element={<PatientDetailPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="orders/create" element={<CreateOrderPage />} />
          <Route path="orders/:id" element={<OrderDetailPage />} />
          <Route path="orders/:id/receipt" element={<ReceiptPage />} />
          <Route
            path="orders/:id/edit"
            element={<CreateOrderPage editMode={true} />}
          />
          <Route path="surveys" element={<SurveysPage />} />
          <Route path="surveys/:id" element={<SurveyDetailPage />} />
          <Route path="states" element={<StatesPage />} />
          <Route path="pharmacies" element={<PharmaciesPage />} />
          <Route
            path="pharmacies/manage"
            element={<PharmacyManagementPage />}
          />
          <Route path="providers" element={<ProvidersPage />} />
          <Route path="medicines" element={<MedicinesPage />} />
          <Route path="receipts" element={<ReceiptsPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Redirect to login if not authenticated */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
